import React from 'react';
import { FormattedMessage } from 'react-intl';

export const ModuleID = 'axp-benefits-view-all';
export const ReadLoyaltyBenefitsVx = 'ReadLoyaltyBenefits.v2';
export const CreateLoyaltyBenefitEnrollmentStatusVx = 'CreateLoyaltyBenefitEnrollmentStatus.v1';
export const rootModule = 'axp-root';
export const benefitHighlights = <FormattedMessage id="view-all.filter.benefit-highlights" defaultMessage="Your Benefit Highlights" />;
export const allBenefits = <FormattedMessage id="view-all.filter.all-benefits" defaultMessage="All Benefits" />;
export const benefitTermsTitle = 'BENEFIT_TERMS';
export const benefitTermsText = 'Benefit Terms';
export const assuranceTitle = 'ASSURANCE_DISCLOSURES';
export const assuranceText = 'AMEX Assurance Company Disclosures';
export const close = <FormattedMessage id="shared.close" defaultMessage="Close" />;
export const suppressCheckboxForLocaleList = ['en-CA', 'fr-CA'];
